import styles from "../styles/Tab.module.css";
import { Navigation, NavigationProps } from "../navigation";

interface iTab extends NavigationProps {
  icon: string;
  filename: string;
  name: Navigation;
}

export default function Tab(params: iTab) {
  return (
      <button
        type="button"
        onClick={() => params.navigateCallback(params.name)}
        aria-current={params.active === params.name ? "page" : undefined}
        className={`${styles.tab} ${
          params.active === params.name && styles.active
        }`}
      >
        <img src={params.icon} alt="" height={18} width={18} />
        <p>{params.filename}</p>
      </button>
  );
}
